import React, { useState, useEffect } from "react";
import { useContext } from "react";
import { Form, Row, Col, Select, Button, Input, Radio, DatePicker, message, Checkbox, Slider, InputNumber } from "antd";
import { platformApi } from "../../../../api";
import moment from "moment";
const { RangePicker } = DatePicker;
const { Item } = Form;
import { ContextAPI } from "../../../../ContextAPI";
import { formatVehicleName } from "../../../../utils/vehicleDisplayName";
// import "./index.less";
const { Option } = Select;
function AdvancedFilters({
  form,
  filteropen,
  setId,
  searchName,
  setPageData,
  setSearch,
  setFilterData,
  setPage,
  data
}) {
  const {
    getFieldDecorator,
    getFieldValue,
    resetFields,
    setFieldsValue
  } = form;
  const jobStatusOptions = [
    "Vehicle Received",
    "Estimation",
    "Estimation Approved",
    "Mechanic Allocated",
    "Spares Ordered",
    "Spares Partially Ordered",
    "Spare Received",
    "Parts Issued",
    "Work In Progress",
    "Final Inspection",
    "Proforma Invoice",
    "Invoice",
    "PAID",
    "Payment Received",
    "Gate Pass"
  ];

  const [models, setModels] = useState([]);
  const [dateFilter, setDateFilter] = useState(false);
  const [type, setType] = useState(null);
  const [fromDate, setFromDate] = useState(null)
  const [users, setUser] = useState(null);
  const [mechanic, setMechanic] = useState([])
  const [selectedModels, setSelectedModels] = useState([]);
  const [serviceTypeCheck, setServiceTypeCheck] = useState(false);
  const [modelCheck, setModelCheck] = useState(false);
  const [jobStatusCheck, setJobStatusCheck] = useState(false);

  const jobStatusCheckAll = (e) => {
    const selectedValues = e.target.checked
      ? jobStatusOptions.map((status) => status)
      : [];
    setJobStatusCheck(e.target.checked);
    setFieldsValue({ jobStatus: selectedValues });
  };

  const [mechanicCheck, setMechanicCheck] = useState(false);
  const { loginCredintials } = useContext(ContextAPI)

  const isMechanic = loginCredintials.role === "Mechanic";

  const serviceType = [
    { key: 1, title: "Free" },
    { key: 2, title: "Engine Overhaul" },
    { key: 3, title: "Paid (UW)" },
    { key: 4, title: "Paid (AW)" },
    { key: 5, title: "AMC" },
    { key: 6, title: "Accidental" },
    { key: 7, title: "Minor" },
    { key: 8, title: "PDI" },
  ];

  const serviceTypeCheckAll = (e) => {
    const selectedValues = e.target.checked ? serviceType.map((obj) => obj.title) : [];
    setServiceTypeCheck(e.target.checked);
    setFieldsValue({ serviceType: selectedValues });
  };

  const mechanicCheckAll = (e) => {
    const selectedValues = e.target.checked ? mechanic.map((obj) => obj.id) : [];
    setMechanicCheck(e.target.checked);
    setFieldsValue({ mechanic: selectedValues });
  };

  useEffect(() => {
    fetchEmployeeBasedOnBanch()
    getMechanic()

    platformApi.get(`/api/vehicleMaster`).then((res) => {
      const { data } = res;
      if (data.code === 200) {
        const { response } = data;
        if (response.code === 200) {
          setModels(response.data);
        }
      }
    });
  }, [data]);


  const getMechanic = () => {
    platformApi
      .get("/api/user")
      .then((result) => {
        let { data } = result;
        if (data.code === 200) {
          let mechanic = data.data.users.filter((item) => {
            return (
              item.profile &&
              item.profile.department &&
              item.profile.department.role === "Mechanic" &&
              item.status === true
            );
          });
          setMechanic(mechanic);
          // setMechanic(data.data.users);
        }
      })
      .catch((error) => {
        console.error("Error on MaterialIssue form : ", error);
        message.error("Unable to fetch joborder", 2);
      });
  };

  const fetchEmployeeBasedOnBanch = () => {
    // console.log(id);
    platformApi
      .post("/api/user/get", {
        size: 1000,
        page: 1,
      })
      .then((result) => {
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            let employees = [];
            response.data.users.forEach((element) => {
              let sale = false;
              element.profile.department.departmentType.forEach((data) => {
                if (data === "Sales") {
                  sale = true;
                  return;
                }
              });
              //sale check
              if (sale) {
                {
                  if (element.status === true) {
                    employees.push(element);
                  }
                }
              }
            });
            setUser(employees);
          }
        }
      })
      .catch((error) => {
        message.error("Unable to fetch Users", 1);
        console.error("Error on Quotations Form : ", error);
      });
  };
  const [range, setRange] = useState([0, null]); // Default range with From = 0
  const maxLimit = 200000; // Upper limit for manual input
  const [kmsFromError, setKmsFromError] = useState('');
  const [kmsToError, setKmsToError] = useState('');

  const handleChangeKms = (value, index) => {
    const newRange = [...range];
    newRange[index] = value;
    setRange(newRange);

    const fromVal = newRange[0];
    const toVal = newRange[1];

    if (fromVal !== null && fromVal !== undefined && toVal !== null && toVal !== undefined) {
      if (Number(fromVal) > Number(toVal)) {
        if (index === 0) {
          setKmsFromError('From kms should be less than To kms');
          setKmsToError('');
        } else {
          setKmsToError('To kms should be greater than From kms');
          setKmsFromError('');
        }
      } else {
        setKmsFromError('');
        setKmsToError('');
      }
    } else {
      setKmsFromError('');
      setKmsToError('');
    }
  };


  // console.log(range,"RANGE")
  const options = models.map(model => ({
    value: model.id,
    label: `${model.modelName}-${model.modelCode}`,
  }));

  const allSelected = selectedModels.length === options.length;

  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedModels([]); // Deselect all
      setFieldsValue({ model: [] });
    } else {
      const allValues = options.map(option => option.value);
      setSelectedModels(allValues); // Select all
      setFieldsValue({ model: allValues });
    }
  };

  const handleChange = (values) => {
    setSelectedModels(values);
    setFieldsValue({ model: values });
  };

  const modelCheckAll = (e) => {
    const selectedValues = e.target.checked ? models.map((obj) => obj.id) : [];
    setModelCheck(e.target.checked)
    // setModelCheck(e.target.checked);
    setFieldsValue({ model: selectedValues });
  };

  const searchValue = () => {
    let mechanic = [];
    setId([]);
    setPageData();
    resetFields();
    setSearch('');

    // Clear all local state variables for manual input fields
    setRange([0, null]); // Reset KMS range to default
    setSelectedModels([]); // Clear selected models
    setFromDate(null); // Clear from date
    setToDate(null); // Clear to date
    setKmsFromError(''); // Clear KMS From validation error
    setKmsToError(''); // Clear KMS To validation error
    setDateFilter(false); // Reset date filter
    setType(null); // Reset type

    if (isMechanic) {
      mechanic[0] = (loginCredintials.employeeId);
    }
    setFilterData({
      "model": null,
      "serviceType": null,
      "mechanic": mechanic,
      "registerNo": null,
      "kms": null,
      "jobCardCreationDate": null,
      "jobStatus": null,
    })
  };

  const handleSubmit = () => {
    const fromVal = range[0];
    const toVal = range[1];
    if (fromVal !== null && fromVal !== undefined && toVal !== null && toVal !== undefined) {
      if (Number(fromVal) > Number(toVal)) {
        setKmsFromError('From kms should be less than To kms');
        setKmsToError('To kms should be greater than From kms');
        message.error("From kms should be less than To kms");
        return;
      }
    }

    const data = {};
    const fields = [
      "model",
      "serviceType",
      "mechanic",
      "registerNo",
      "kms",
      "jobCardCreationDate",
      "jobStatus"
    ];

    fields.forEach((field) => {
      const value = getFieldValue(field);

      if (
        (!Array.isArray(value) && value) ||
        (Array.isArray(value) && value.length > 0)
      ) {
        // console.log(value, "VLA");
        if (field.includes("Date") || field.includes("kms")) {
          // console.log(field)
          if (Array.isArray(value)) {
            if (field === "jobCardCreationDate") {
              data[`from`] = moment(value[0]).startOf("day").toISOString();
              data[`to`] = moment(value[1]).endOf("day").toISOString();
            } else {
              // console.log(field,"else")
              if (value[0] == 0 && value[1] == 0) {
                data[`serviceKmFrom`] = null;
                data[`serviceKmTo`] = null;
              }
              data[`serviceKmFrom`] = value[0];
              data[`serviceKmTo`] = value[1];
            }
          }
        } else {
          data[field] = value;
        }
      } else {
        if (field !== "jobCardCreationDate") data[field] = null;
      }
    });
    // console.log(data,"check")
    setFilterData(data);
  };

  useEffect(() => {
    setModelCheck(false)
    setMechanicCheck(false)
    setServiceTypeCheck(false)
    setRange([])
    setKmsFromError('')
    setKmsToError('')
  }, [filteropen])

  return (
    <div>
      {filteropen && (
        <div className="AdvancedFilters" >
          <Form>
            <Row>
              <h3>Advanced Filters</h3>
            </Row>

            <Row gutter={25}>
              {/* Vehicle Model */}
              <Col span={6}>
                {models && (
                  <Item label="Vehicle Model">
                    <Row gutter={8} align="middle">
                      <Col span={16}>
                        {getFieldDecorator("model")(
                          <Select
                            className="vehicle-select"
                            mode="multiple"
                            showSearch
                            placeholder="Select Vehicle Model"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              String(option.props.children || "")
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {models.map((model) => (
                              <Select.Option key={model.id} value={model.id}>
                                {formatVehicleName(model)}
                              </Select.Option>
                            ))}
                          </Select>
                        )}
                      </Col>
                      <Col span={8}>
                        <Checkbox checked={modelCheck} onChange={modelCheckAll}>
                          All
                        </Checkbox>
                      </Col>
                    </Row>
                  </Item>
                )}
              </Col>

              {/* Service Type */}
              <Col span={6}>
                <Item label="Service Type">
                  <Row gutter={8} align="middle">
                    <Col span={16}>
                      {getFieldDecorator("serviceType")(
                        <Select
                          mode="multiple"
                          showSearch
                          placeholder="Select Service Type"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {serviceType.map((service) => (
                            <Select.Option key={service.key} value={service.title}>
                              {service.title}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Col>
                    <Col span={8}>
                      <Checkbox checked={serviceTypeCheck} onChange={serviceTypeCheckAll}>
                        All
                      </Checkbox>
                    </Col>
                  </Row>
                </Item>
              </Col>

              {/* Mechanic */}
              <Col span={6}>
                {!isMechanic && mechanic && (
                  <Item label="Mechanic">
                    <Row gutter={8} align="middle">
                      <Col span={16}>
                        {getFieldDecorator("mechanic")(
                          <Select
                            mode="multiple"
                            showSearch
                            placeholder="Select Mechanic"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {mechanic.map((m) => (
                              <Select.Option key={m.id} value={m.id}>
                                {m.profile.employeeName}
                              </Select.Option>
                            ))}
                          </Select>
                        )}
                      </Col>
                      <Col span={8}>
                        <Checkbox checked={mechanicCheck} onChange={mechanicCheckAll}>
                          All
                        </Checkbox>
                      </Col>
                    </Row>
                  </Item>
                )}
              </Col>

              {/* Job Status */}
              <Col span={6}>
                <Item label="Job Status">
                  <Row gutter={8} align="middle">
                    <Col span={16}>
                      {getFieldDecorator("jobStatus")(
                        <Select
                          mode="multiple"
                          showSearch
                          placeholder="Select Job Status"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {jobStatusOptions.map((status) => (
                            <Select.Option key={status} value={status}>
                              {status}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Col>
                    <Col span={8}>
                      <Checkbox checked={jobStatusCheck} onChange={jobStatusCheckAll}>
                        All
                      </Checkbox>
                    </Col>
                  </Row>
                </Item>
              </Col>
            </Row>


            <Row gutter={25}>
              <Col span={8}>

                <Item label="Register Number">
                  {getFieldDecorator("registerNo")(
                    <Input placeholder="Enter the Register Number" />
                  )}
                </Item>

              </Col>
              <Col span={8}>
                <Item label="Service KMs">
                  {getFieldDecorator("kms", { initialValue: range })(
                    <>
                      <Row gutter={16}>
                        <Col span={11}>
                          <Item
                            validateStatus={kmsFromError ? "error" : ""}
                            help={kmsFromError || null}
                            style={{ marginBottom: 0 }}
                          >
                            <InputNumber
                              min={0}
                              max={maxLimit}
                              value={range[0] || null}
                              step={1000}
                              onChange={(value) => handleChangeKms(value, 0)}
                              style={{ width: "100%" }}
                              placeholder="From"
                            />
                          </Item>
                        </Col>
                        <Col span={2} style={{ textAlign: "center", lineHeight: "32px" }}>to</Col>
                        <Col span={11}>
                          <Item
                            validateStatus={kmsToError ? "error" : ""}
                            help={kmsToError || null}
                            style={{ marginBottom: 0 }}
                          >
                            <InputNumber
                              min={0}
                              max={maxLimit}
                              value={range[1] || null}
                              step={1000}
                              onChange={(value) => handleChangeKms(value, 1)}
                              style={{ width: "100%" }}
                              placeholder="To"
                            />
                          </Item>
                        </Col>
                      </Row>
                    </>
                  )}
                </Item>
              </Col>

              <Col span={8}>
                <Item label="Job Card Creation Date">
                  {getFieldDecorator("jobCardCreationDate")(
                    <RangePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
                  )}
                </Item>
              </Col>
            </Row>

            <Row gutter={25}>
              <Col span={3}>
                <Button type="primary" onClick={handleSubmit}>
                  Search
                </Button>
              </Col>
              <Col span={3}>
                <Button type="ghost" onClick={searchValue}>
                  Clear
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      )}
    </div>
  );
}

const WrappedAdvancedFilter = Form.create()(AdvancedFilters);
export default WrappedAdvancedFilter;